export const LIGHT_DARK = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
};

export type LightDark = keyof typeof LIGHT_DARK;
